module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page x. ",
      "epub:type": "pagebreak",
      "id": "pg_x",
      "role": "doc-pagebreak"
    }
  }, [_c('b', [_vm._v("Contents")])])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("I.")]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_vm._v("Definitions of mo‘o")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maunakea")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the effects of shedding skin")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome to the gut house")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He mo‘o, he wahine")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kino")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mo‘olelo is the theory")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My grandma tells")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memory as missionary position")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to swallow a colonizer")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catalogue of gossip, warnings & other talk of mo‘o, aka an ‘ōiwi abecedarian")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t have sex with gods")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When you say “protestors” instead of “protectors”")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("II.")]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_vm._v("Definitions of mo‘o")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iwi hilo means thigh bone means core of one’s being")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maui county fair")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In search of a different ending")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mercy")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ex is a verb")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After she leaves you, femme")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons in quarantine")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So sacred, so queer")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adze-shaped rain")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page xi. ",
      "epub:type": "pagebreak",
      "id": "pg_xi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("III.")]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_vm._v("Erasure triptych")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘ai")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sirens      out")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("aloha")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("IV.")]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_vm._v("Definitions of mo‘o")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirst traps")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Myth bitch")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting ready for work")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For sisters who pray with fire")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dirtiest grand")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The opposite of dispossession is not possession; it is connection")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ea of enough")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fire in Mākena")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recovery, Waikīkī")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New patient form—medical history—creative option")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing Ka‘uiki")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basket")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shapeshifters banned, censored, or otherwise shit-listed, aka chosen family poem")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/mahalo",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Mahalo")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0